// tslint:disable
export var ProgramUsageType;
(function (ProgramUsageType) {
    // Hub
    ProgramUsageType[ProgramUsageType["Hub"] = 1] = "Hub";
    // Copay
    ProgramUsageType[ProgramUsageType["Copay"] = 2] = "Copay";
    // Pap
    ProgramUsageType[ProgramUsageType["PatientAssitanceProgram"] = 3] = "PatientAssitanceProgram";
    // ClinicalTrial
    ProgramUsageType[ProgramUsageType["ClinicalTrial"] = 4] = "ClinicalTrial";
})(ProgramUsageType || (ProgramUsageType = {}));
ProgramUsageType['HUB'] = 1;
ProgramUsageType['COPAY'] = 2;
ProgramUsageType['PATIENTASSITANCEPROGRAM'] = 3;
ProgramUsageType['CLINICALTRIAL'] = 4;
//# sourceMappingURL=ProgramUsageType.js.map